import React from "react";
import { useSelector } from "react-redux";
import ItemSinger from "./ItemSinger";

const ListVoting = () => {
  const listSingers = useSelector((state) => state?.user?.listSingers) || [];

  const voteOfUser = useSelector((state) => state?.user?.voteOfUser || 0);
  const isLogin = useSelector((state) => state?.user?.profile?.id);
  if (!listSingers.length) return null;

  return (
    <>
      <div className="max-w-[92%] mx-auto px-4">
        <div className="vote-list-bar-bg h-[6.5vw] mb-[5vw] flex font-gilroy justify-center items-center text-[3vw] w-[47vw] mx-auto uppercase font-bold text-white ">
          <span className="translate-y-[2vw]">
            Danh sách bình chọn
          </span>
        </div>
        <div className="text-white tracking-wide text-[3.5vw] font-gilroy text-center title-shadow">
          {/* TOP {listSingers?.length || 0} ĐƯỢC YÊU THÍCH NHẤT */}
          <div>HÃY ĐỂ LẠI BÌNH CHỌN CỦA BẠN</div>
        </div>
      </div>
      <div id="list-voting-singer" className="mx-auto w-full md:pt-[20px] border mt-3 [border-image:linear-gradient(to_top,#008cd5,#0ee2ff)_30]">
        <div className="pl-[6vw] pr-[4vw] py-[5vw] ">
          <div className="max-w-full pr-2">
            <div>
              {listSingers.map((item, index) => (
                <ItemSinger
                  key={item.id}
                  data={{ ...item, order: index + 1 }}
                  disableVote={voteOfUser === 0 && isLogin}
                  needLogin={!isLogin}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="h-[5vw]"></div>
    </>
  );
};

export default ListVoting;
